export const picklist = {
  root: {
    gap: "{gap.16}",
  },
  controls: {
    gap: "{gap.8}",
  },
};
